// extracted by mini-css-extract-plugin
module.exports = {"arrowItem":"_56adb3b6","isLeft":"_5f180afb","arrow":"_620f7023"};